import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  presentingAgentName: PropTypes.string.isRequired,
  agentSignInPath: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  agentPhotoUrl: PropTypes.string
};

const ClientLandingHeader = ({
  presentingAgentName,
  agentSignInPath,
  clientName,
  agentPhotoUrl = null
}) => {
  return (
    <div className="client-landing-header">
      <div className="client-landing-header__agent">
        {agentPhotoUrl ? (
          <img
            className="client-landing-header__agent-photo"
            src={agentPhotoUrl}
            alt={presentingAgentName || "Agent"}
          />
        ) : (
          <div
            className="client-landing-header__agent-photo client-landing-header__agent-photo--placeholder"
            data-testid="agent-photo-placeholder"
          >
            <i className="fa fa-user" aria-hidden="true" />
          </div>
        )}
        <div className="client-landing-header__agent-info">
          <div className="client-landing-header__label">Presented by</div>
          <div className="client-landing-header__name">{presentingAgentName}</div>
        </div>
        <a href={agentSignInPath} className="client-landing-header__sign-in">
          <span className="d-none d-sm-inline mr-2">Agent Sign In</span>
          <i className="fa fa-sign-in" aria-hidden="true" />
        </a>
      </div>
      <div className="client-landing-header__client">
        <div className="client-landing-header__label">Campaign Report Prepared For</div>
        <div className="client-landing-header__name">{clientName}</div>
      </div>
    </div>
  );
};

ClientLandingHeader.propTypes = propTypes;

export default ClientLandingHeader;
